import ServiceBase from "./apiServiceBase";

import { objectToUrlParams } from "../utils/helpers";

const { REACT_APP_INVOICE_SERVER_URL } = process.env;

class InvoicesApiService extends ServiceBase {
  async getDashboardData(request) {
    const params = objectToUrlParams(request);

    const response = await this.get(`${REACT_APP_INVOICE_SERVER_URL}/dashboard?${params}`);

    return response;
  }

  async getInvoiceTypes() {
    const response = await this.get(`${REACT_APP_INVOICE_SERVER_URL}/invoices/types`);

    return response;
  }

  async searchInvoices(request) {
    const params = objectToUrlParams(request);
    const response = await this.get(`${REACT_APP_INVOICE_SERVER_URL}/invoices?${params}`);
    return response;
  }

  async getName() {
    const response = await this.get(`${REACT_APP_INVOICE_SERVER_URL}/group-invoices/code`);
    return response;
  }

  async getInvoice(invoiceId) {
    const response = await this.get(`${REACT_APP_INVOICE_SERVER_URL}/invoices/${invoiceId}`);
    return response;
  }

  async createInvoice(data) {
    const response = await this.post(`${REACT_APP_INVOICE_SERVER_URL}/invoices`, data);
    return response;
  }

  async getPaymentGatewayToken() {
    const response = await this.get(`${REACT_APP_INVOICE_SERVER_URL}/token`);
    return response;
  }

  async createStatement(request) {
    const response = await this.post(`${REACT_APP_INVOICE_SERVER_URL}/group-invoices`, request);
    return response;
  }

  async updateStatement(request, id) {
    const response = await this.patch(`${REACT_APP_INVOICE_SERVER_URL}/group-invoices/${id}`, request);
    return response;
  }

  async deactivateStatement(statementId) {
    const response = await this.delete(`${REACT_APP_INVOICE_SERVER_URL}/group-invoices/${statementId}`);
    return response;
  }

  async downloadInvoices(request) {
    const params = objectToUrlParams(request);

    const response = await this.get(`${REACT_APP_INVOICE_SERVER_URL}/reports/download/list?${params}`);
    return response;
  }

  async downloadInvoice(id, lng) {
    const response = await this.get(`${REACT_APP_INVOICE_SERVER_URL}/reports/download/invoice/${id}?lang=${lng}`);
    return response;
  }

  async printPayment(id, lng) {
    const response = await this.get(`${REACT_APP_INVOICE_SERVER_URL}/reports/download/payment/${id}?lang=${lng}`);
    return response;
  }

  async getAgent(id) {
    const response = await this.get(`${REACT_APP_INVOICE_SERVER_URL}/invoices/agent/${id}`);
    return response;
  }

  async searchAgent(tin) {
    const response = await this.get(`${REACT_APP_INVOICE_SERVER_URL}/customers/${tin}`);
    return response;
  }

  async addAgent(invoiceId, agentCode) {
    const response = await this.patch(`${REACT_APP_INVOICE_SERVER_URL}/invoices/agent/${invoiceId}`, {
      agentCode
    });
    return response;
  }

  async deleteAgent(invoiceId) {
    const response = await this.delete(`${REACT_APP_INVOICE_SERVER_URL}/invoices/agent/${invoiceId}`);
    return response;
  }

  async refreshWebHook(request) {
    const response = await this.patch(`${REACT_APP_INVOICE_SERVER_URL}/webhook-invocations`, request);

    return response;
  }

  async checkWebHook(invoiceId) {
    const response = await this.get(
      `${REACT_APP_INVOICE_SERVER_URL}/webhook-invocations/details?invoiceId=${invoiceId}`
    );

    return response;
  }

  async checkVoidAvailable(invoiceId) {
    const response = await this.get(`${REACT_APP_INVOICE_SERVER_URL}/invoices/${invoiceId}/action-info`);

    return response;
  }

  async voidInvoice({ data: invoiceId, justification }) {
    const response = await this.patch(`${REACT_APP_INVOICE_SERVER_URL}/invoices/${invoiceId}/void`, {
      ...justification
    });

    return response;
  }

  async changeInvoiceStatus(data) {
    const response = await this.post(`${REACT_APP_INVOICE_SERVER_URL}/gateway/notifications`, data);

    return response;
  }

  async getInvoicesByMerchantRefAndCode(data) {
    const { merchantRef, merchantCode } = data;
    const response = await this.get(
      `${REACT_APP_INVOICE_SERVER_URL}/invoices/merchant-references/${merchantRef}?merchantCode=${merchantCode}`
    );

    return response;
  }
}

export default new InvoicesApiService();
